/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPhotoVideo} from '@fortawesome/pro-duotone-svg-icons';

const MediaTypeIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faPhotoVideo} {...props} />
);

export default MediaTypeIcon;
